import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatepickerTab } from '../../../constants/datepicker-tab.enum';
import { HeightAnimationDirective } from '../../../directives/height-animation/height-animation.directive';

@Component({
  selector: 'rx-tab-item',
  standalone: true,
  imports: [CommonModule, HeightAnimationDirective],
  templateUrl: './tab-item.component.html',
  styleUrl: './tab-item.component.scss',
})
export class TabItemComponent {
  @Input() title: string;
  @Input() tabId: DatepickerTab;
  @Input() selected = false;
  @Input() testId: string;
  icon = input<string | null>(null);
}
